module.exports = __webpack_public_path__ + "img/museum.47c2c6cd.svg";